<template>
  <div class="faq row full-width column-mobile">
    <div class="info-part">
      <Heading font-size="26px" tag="h2">{{ $t('category.most_popular_questions') }} {{ category_name }}:</Heading>
      <Text>{{ $t('category.common_questions') }} {{ category_name }}</Text>
    </div>
    <div class="full-width">
      <SpoilerTabs :tabs="Object.keys(items)">
        <template v-slot:[getTabSlotName(index)] v-for="(item, index) in Object.values(items)">
          <Text>{{ item.sub_title }}</Text>

          <List :items="item.li">
            <template v-slot:[getListSlotName(index)]="props" v-for="(item, index) in Object.values(item.li)">
              <nuxt-link :to="'/shop/'+props.li.url">{{ props.li.name }}</nuxt-link>
              - {{ props.li.price }}/{{ props.li.unit }}
            </template>
          </List>
        </template>
      </SpoilerTabs>
    </div>
  </div>
</template>

<script>
import SpoilerTabs from "@/components/molecules/SpoilerTabs.vue";
import Heading from "@/components/atoms/Heading.vue";
import Text from "@/components/atoms/Text.vue";
import List from "@/components/molecules/List.vue";

export default {
  props: {
    items: Object,
    category_name: String,
  },
  components: {List, Text, Heading, SpoilerTabs},
  methods: {
    getTabSlotName(index) {
      return `tab-content-${index}`;
    },
    getListSlotName(index) {
      return `li-content-${index}`;
    },
  }
}
</script>

<style scoped>
.faq {
  align-items: flex-start;
  margin-top: 96px;
}

.info-part {
  gap: 18px;
}

a {
  text-decoration: underline;
}
</style>
